module.exports = __webpack_public_path__ + "static/media/whitearrowdown.e985b13e.svg";